export default __webpack_public_path__ + "static/media/FlyingFrog21.e53f1975.png";